import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ResultPageIntro() {
  const { t } = useTranslation();
  return (
    <Box>
      <Box>
        <Box>
          <Typography fontSize={30} variant="h5">
            {t("introductions.resultPage.text1")}
          </Typography>
        </Box>
        <Box mt={4}>
          <Typography>{t("introductions.resultPage.text2")}</Typography>
        </Box>
        <Box mt={2}>
          <Typography>{t("introductions.resultPage.text3")}</Typography>
        </Box>
      </Box>
    </Box>
  );
}
